module.exports = __webpack_public_path__ + "static/bitmoji.52b13603.png";


//////////////////
// WEBPACK FOOTER
// ./src/parts/home/About/bitmoji.png
// module id = 498
// module chunks = 35783957827783